<script context="module">
  import PageHead from "./../Components/PageHead.svelte";
  import Breadcrumb from "./Partials/Breadcrumb.svelte";
  import Alerts from "../Shared/Alerts.svelte";
  import Address from "../Shared/Address.svelte";
  export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
  import { useForm, inertia } from "@inertiajs/svelte";

  export let address;

  const form = useForm("addressSearchForm", {
    ownerAddr: {
      Address1: address.OwnerAddress?.Address1,
      Address2: address.OwnerAddress?.Address2,
      City: address.OwnerAddress?.City,
      State: address.OwnerAddress?.State ?? "",
      ZipCode: address.OwnerAddress?.ZipCode,
      County: address.OwnerAddress?.County ?? "",
    },
    renewalAddr: {
      Address1: address.RenewalAddress?.Address1,
      Address2: address.RenewalAddress?.Address2,
      City: address.RenewalAddress?.City,
      State: address.RenewalAddress?.State ?? "",
      ZipCode: address.RenewalAddress?.ZipCode,
    },
  });

  let ownerAddressErrors = [],
    renewalAddressErrors = [];

  function handleSubmit() {
    $form.clearErrors();
    $form.post(route("address.change"), {
      onError: (e) => {
        ownerAddressErrors = [];
        renewalAddressErrors = [];

        Object.entries(e).filter((e) => {
          if (e[0].includes("ownerAddr")) {
            ownerAddressErrors.push(e[1]);
          } else if (e[0].includes("renewalAddr")) {
            renewalAddressErrors.push(e[1]);
          }
        });
      },
    });
  }

  function inputVIN(e) {
    $form.vin = formatGeneral(e.target.value, {
      blocks: [4],
      numericOnly: true,
    });
  }
</script>

<PageHead>
  <svelte:fragment slot="title">Change Address</svelte:fragment>
  <svelte:fragment slot="tagline"
    >Update the Physical or Mailing Address associated with this vehicle.</svelte:fragment
  >
  <Breadcrumb slot="breadcrumb">
    <span slot="home"></span>
    <span slot="address"></span>
    <span slot="address_change"></span>
  </Breadcrumb>
</PageHead>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <Alerts {form} skip={["ownerAddr", "renewalAddr"]} />
        <Address
          {form}
          autoShow={true}
          updateAddress={true}
          bind:ownerAddressErrors
          bind:renewalAddressErrors
        />
      </div>
      <div class="card-footer">
        <div class="row g-2 justify-content-between my-1">
          <div class="col-3 d-grid">
            <a
              href={window.route("address.index")}
              use:inertia
              class="btn btn-secondary">Cancel</a
            >
          </div>
          <div class="col-3 d-grid">
            <button
              class="btn btn-success"
              on:click|preventDefault={handleSubmit}
              disabled={$form.processing}>Submit</button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
